import React, { useState } from "react";
import AppInputNew from "./AppInputNew";

/**
 * Example usage of AppInputNew component showing how to use it
 * with Tailwind classes for customization
 */
const AppInputNewExample: React.FC = () => {
	const [textValue, setTextValue] = useState("");
	const [numberValue, setNumberValue] = useState<number>(42);
	const [emailValue, setEmailValue] = useState("");

	return (
		<div className="p-6 max-w-md mx-auto space-y-4">
			<h2 className="text-xl font-bold mb-4">AppInputNew Examples</h2>

			{/* Basic text input */}
			<AppInputNew
				label="Basic Text Input"
				value={textValue}
				onChangeText={setTextValue}
				placeholder="Enter some text..."
			/>

			{/* Input with icon */}
			<AppInputNew
				label="Email Input"
				type="email"
				icon="email"
				value={emailValue}
				onChangeText={setEmailValue}
				placeholder="Enter your email"
				mandatory
			/>

			{/* Number input with custom styling */}
			<AppInputNew
				label="Number Input"
				type="number"
				value={numberValue}
				onChangeNumber={setNumberValue}
				min={0}
				max={100}
				containerClassName="mb-8"
				wrapperClassName="border-2 border-blue-300 focus-within:border-blue-500"
				inputClassName="text-center font-bold"
			/>

			{/* Input with prefix */}
			<AppInputNew
				label="Price Input"
				type="number"
				prefix="SEK"
				icon="economy"
				value={numberValue}
				onChangeNumber={setNumberValue}
				placeholder="0.00"
			/>

			{/* Disabled input */}
			<AppInputNew
				label="Disabled Input"
				value="This is disabled"
				disabled
				description="This input is disabled for demonstration"
			/>

			{/* Invalid input */}
			<AppInputNew
				label="Invalid Input"
				value="invalid@email"
				isValid={false}
				errors="Please enter a valid email address"
			/>

			{/* Custom styled input using className */}
			<AppInputNew
				label="Custom Styled Input"
				value={textValue}
				onChangeText={setTextValue}
				placeholder="Custom styling..."
				containerClassName="mb-2"
				wrapperClassName="bg-gray-50 border-gray-400 rounded-lg shadow-sm focus-within:shadow-md"
				inputClassName="text-lg text-purple-700 placeholder-purple-400"
			/>
		</div>
	);
};

export default AppInputNewExample;
